import { useMediaQuery } from "react-responsive";

export const MediaQueryTool = () => {
  const isXS = useMediaQuery({ query: "(max-width: 575px)" });
  const isSM = useMediaQuery({
    query: "(min-width: 576px) and (max-width: 767px)",
  });
  const isMD = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 991px)",
  });
  const isLG = useMediaQuery({
    query: "(min-width: 992px) and (max-width: 1199px)",
  });
  const isXL = useMediaQuery({ query: "(min-width: 1200px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });

  return { isXS, isSM, isMD, isLG, isXL, isPortrait };
};

export default MediaQueryTool;
